export default "__VITE_ASSET__DUVBw2Ve__"